function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { useDirection, usePrefixCls } from '@byte-design/config';
import { CheckWrapper } from '../../units/check-wrapper';
export function Radio(props) {
  var className = props.className,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$checked = props.checked,
      checked = _props$checked === void 0 ? false : _props$checked,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      children = props.children,
      extra = _objectWithoutProperties(props, ["className", "size", "checked", "disabled", "onChange", "onValueChange", "children"]);

  var rtl = useDirection() === 'rtl';
  var ref = useRef(null);
  var cls = classnames(usePrefixCls('radio', {
    size: size,
    checked: checked,
    disabled: disabled,
    rtl: rtl
  }), className);
  var circleCls = usePrefixCls('radio-circle', {
    size: size
  });
  var labelCls = usePrefixCls('radio-label');
  return React.createElement(CheckWrapper, Object.assign({}, extra, {
    type: "radio",
    className: cls,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    onValueChange: onValueChange,
    waveElementRef: ref
  }), React.createElement("span", {
    className: circleCls,
    ref: ref
  }), !!children && React.createElement("span", {
    className: labelCls
  }, children));
}